module.exports = "/fonts/Axis.svg";